export const PERMIT_TYPES = [
    {
        value: "felling",
        label: "Abate",
    },
    {
        value: "cutting",
        label: "Serragem",
    },
    {
        value: "clearing",
        label: "Desbravamento",
    },
    {
        value: "transport",
        label: "Transporte",
    },
];
